import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Component, Input, HostBinding, NgModule } from '@angular/core';

class SeFeListComponent {
    constructor() {
        this.dividers = true;
        this.baseClass = true;
    }
    get dividersClass() { return this.dividers; }
}
SeFeListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeListComponent, selector: "se-fe-list", inputs: { dividers: ["seFeDataDividers", "dividers"] }, host: { properties: { "class.se-fe-list": "this.baseClass", "class.se-fe-list--dividers": "this.dividersClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;font:var(--se-body-font)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-list',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-list.component.scss'],
                }]
        }], propDecorators: { dividers: [{
                type: Input,
                args: ['seFeDataDividers']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-list']
            }], dividersClass: [{
                type: HostBinding,
                args: ['class.se-fe-list--dividers']
            }] } });

class SeFeListItemComponent {
    constructor() {
        this.baseClass = true;
    }
}
SeFeListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeListItemComponent, selector: "se-fe-list-item", host: { properties: { "class.se-fe-list-item": "this.baseClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:block;padding:var(--se-content-spacing)}:host-context(.se-fe-list--dividers):not(:first-child){border-top:1px solid var(--se-divider)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListItemComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-list-item',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-list-item.component.scss'],
                }]
        }], propDecorators: { baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-list-item']
            }] } });

class SeFeListFooterComponent {
    constructor() {
        this.border = true;
        this.center = false;
        this.baseClass = true;
    }
    get borderClass() { return this.border; }
    get centerClass() { return this.center; }
}
SeFeListFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SeFeListFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: SeFeListFooterComponent, selector: "se-fe-list-footer", inputs: { border: ["seFeDataBorder", "border"], center: ["seFeDataCenter", "center"] }, host: { properties: { "class.se-fe-list-footer": "this.baseClass", "class.se-fe-list-footer--border": "this.borderClass", "class.se-fe-list-footer--center": "this.centerClass" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [":host{display:flex;grid-gap:calc(var(--se-content-spacing) + var(--se-content-spacing-small));gap:calc(var(--se-content-spacing) + var(--se-content-spacing-small));padding:var(--se-content-spacing)}:host.se-fe-list-footer--border{border-top:1px solid var(--se-divider)}:host.se-fe-list-footer--center{text-align:center}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListFooterComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'se-fe-list-footer',
                    template: '<ng-content></ng-content>',
                    styleUrls: ['./se-fe-list-footer.component.scss'],
                }]
        }], propDecorators: { border: [{
                type: Input,
                args: ['seFeDataBorder']
            }], center: [{
                type: Input,
                args: ['seFeDataCenter']
            }], baseClass: [{
                type: HostBinding,
                args: ['class.se-fe-list-footer']
            }], borderClass: [{
                type: HostBinding,
                args: ['class.se-fe-list-footer--border']
            }], centerClass: [{
                type: HostBinding,
                args: ['class.se-fe-list-footer--center']
            }] } });

class SeFeListModule {
}
SeFeListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SeFeListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListModule, declarations: [SeFeListComponent,
        SeFeListItemComponent,
        SeFeListFooterComponent], imports: [CommonModule], exports: [SeFeListComponent, SeFeListItemComponent, SeFeListFooterComponent] });
SeFeListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: SeFeListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SeFeListComponent,
                        SeFeListItemComponent,
                        SeFeListFooterComponent
                    ],
                    imports: [CommonModule],
                    exports: [SeFeListComponent, SeFeListItemComponent, SeFeListFooterComponent]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { SeFeListComponent, SeFeListFooterComponent, SeFeListItemComponent, SeFeListModule };
